import { render } from "./VentaFacturar.vue?vue&type=template&id=10c68d49&scoped=true"
import script from "./VentaFacturar.vue?vue&type=script&lang=js"
export * from "./VentaFacturar.vue?vue&type=script&lang=js"

import "./VentaFacturar.vue?vue&type=style&index=0&id=10c68d49&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c68d49"]])

export default __exports__